import{__exports as e}from"../../../../_virtual/noop.js";Object.defineProperty(e,"__esModule",{value:!0}),e.default=function(){};
//# sourceMappingURL=noop.js.map
